import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Row, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import { colValue, compName, month } from "../../../../utils/constant";
import Loader from "../../../Loader/Loader";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import WidgetDetailModal from "../../WidgetDetailModal";
import AddWidgetModal from "../../AddWidgetModal";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import moment from "moment";

const RecapReport = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const userDetail = commonService.getLoginUserData();
    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const RecapReportTableData = [
        {
            bucket: "Today",
            occpct: "0",
            adr: "0",
            room_revenue: "0",
            no_shows: "0",
            cancellations: "0",
        },
        {
            bucket: "Yesterday",
            occpct: "0",
            adr: "0",
            room_revenue: "0",
            no_shows: "0",
            cancellations: "0",
        },
        {
            bucket: "MTD",
            occpct: "0",
            adr: "0",
            room_revenue: "0",
            no_shows: "0",
            cancellations: "0",
        },
        {
            bucket: "YTD",
            occpct: "0",
            adr: "0",
            room_revenue: "0",
            no_shows: "0",
            cancellations: "0",
        },

    ];

    const [selectedYear, setSelectedYear] = useState(new Date(para?.asOfDate).getFullYear());
    const [recapReportData, setRecapReportData] = useState(null);
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );

    const [recapReportLoading, setRecapReportLoading] = useState(true);

    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const getRecapReportDetail = async () => {
        setRecapReportLoading(true);
        let onTheBookResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DYNAMIC_PRICING.SNP_RECAP_REPORT,
                body: {
                    asofdate: para?.asOfDate,
                    propertycode: para?.propertyCode,
                },
            },
            false
        );
        let response = apiResponse(false, onTheBookResponse);

        if (response?.isValidate) {
            const recapMap = response?.data?.data?.reduce((acc, item) => {
                acc[item.bucket] = item;
                return acc;
            }, {});

            setRecapReportData(recapMap);
            setRecapReportLoading(false);
        }

        if (!response?.isValidate) {
            setRecapReportData(RecapReportTableData);
            setRecapReportLoading(false);
        }
    };

    const [tblids, settblids] = useState({
        RecapReport: commonService.GenerateGUID(),
    });

    useEffect(() => {
        if (api === 0) {
            setRecapReportData(RecapReportTableData);
        } else {
            if (para?.asOfDate) {
                getRecapReportDetail();
            }
        }
    }, [para?.asOfDate, selectedYear]);

    return (
        <div className="widget-container" style={{position: "relative", padding: "0 5px"}}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("RecapReport", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.RecapReport,
                                    "Recap Report",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RecapReport", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.Re,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RecapReport", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.RecapReport}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.RecapReport,
                                    `${para?.propertyCode}-Recap Report-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}

            <div className="ViewPropertySetupTable">
                <div className="stripped__table">
                    <Table id={tblids.RecapReport} responsive className="text-nowrap">
                        <thead>

                            <tr>
                                <th colSpan={5} className="text-center">
                                    Recap Report ({selectedYear})
                                </th>
                            </tr>


                            <tr>
                                <th></th>
                                <th>Yesterday</th>
                                <th>Today</th>
                                <th>MTD</th>
                                <th>YTD</th>
                            </tr>
                        </thead>

                        <tbody>
                            {recapReportLoading ? (
                                <tr style={{ height: "80px", position: "relative" }}>
                                    <Loader />
                                </tr>
                            ) : (
                                <>
                                    {/* OCC */}
                                    <tr>
                                        <td>Occ</td>
                                        <td>{Math.round(Number(recapReportData?.Yesterday?.occpct)) || 0}%</td>
                                        <td>{Math.round(Number(recapReportData?.Today?.occpct)) || 0}%</td>
                                        <td>{Math.round(Number(recapReportData?.MTD?.occpct)) || 0}%</td>
                                        <td>{Math.round(Number(recapReportData?.YTD?.occpct)) || 0}%</td>
                                    </tr>

                                    {/* ADR */}
                                    <tr>
                                        <td>ADR</td>

                                        <td>
                                            {commonService.formateAmount(
                                                recapReportData?.Yesterday?.adr
                                            )}
                                        </td>
                                        <td>
                                            {commonService.formateAmount(
                                                recapReportData?.Today?.adr
                                            )}
                                        </td>
                                        <td>
                                            {commonService.formateAmount(recapReportData?.MTD?.adr)}
                                        </td>

                                        <td>
                                            {commonService.formateAmount(recapReportData?.YTD?.adr)}
                                        </td>
                                    </tr>

                                    {/* Revenue */}
                                    <tr>
                                        <td>Revenue</td>

                                        <td>
                                            {commonService.formateAmount(
                                                recapReportData?.Yesterday?.room_revenue
                                            )}
                                        </td>
                                        <td>
                                            {commonService.formateAmount(
                                                recapReportData?.Today?.room_revenue
                                            )}
                                        </td>
                                        <td>
                                            {commonService.formateAmount(
                                                recapReportData?.MTD?.room_revenue
                                            )}
                                        </td>
                                        <td>
                                            {commonService.formateAmount(
                                                recapReportData?.YTD?.room_revenue
                                            )}
                                        </td>
                                    </tr>

                                    {/* No Shows */}
                                    <tr>
                                        <td>No Shows</td>

                                        <td>{recapReportData?.Yesterday?.no_shows}</td>
                                        <td>{recapReportData?.Today?.no_shows}</td>
                                        <td>{recapReportData?.MTD?.no_shows}</td>
                                        <td>{recapReportData?.YTD?.no_shows}</td>
                                    </tr>

                                    {/* Cancellations */}
                                    <tr>
                                        <td>Cancellations</td>

                                        <td>{recapReportData?.Yesterday?.cancellations}</td>
                                        <td>{recapReportData?.Today?.cancellations}</td>
                                        <td>{recapReportData?.MTD?.cancellations}</td>
                                        <td>{recapReportData?.YTD?.cancellations}</td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>

            {api !== 0 && <Comments widgetDetails={para} editorId={"RecalReport"} />}

            {showNoteSidebar && (
                <AddWidgetModal
                    showModal={showNoteSidebar}
                    closeModal={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};

export default RecapReport;
